// src/components/Layout.tsx
import { ReactNode } from 'react';
import Sidebar from './Sidebar';
import { Toaster } from "react-hot-toast";

const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex">
      <Sidebar />
      <main className="flex-1 p-6 bg-gray-50 min-h-screen">{children}</main>
      <Toaster position="top-right" />
    </div>
  );
};

export default Layout;
